import { render, staticRenderFns } from "./ExpiryDateDialog.vue?vue&type=template&id=0cf14749"
import script from "./ExpiryDateDialog.vue?vue&type=script&lang=js"
export * from "./ExpiryDateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports